import { makeStyles } from '@material-ui/core/styles'

const programViewStyles = makeStyles((theme) => ({
  programViewStyle: {
    // margin: '2% 2% 1.3%',
    // border : '2px solid black',
    height: 'auto',
    background: '#FFFFFF',
    display: 'flex',
    // alignItems: 'top',
    justifyContent: 'space-between', //vertical center of the parent element
  },
  cardWrapper: {
    margin: '2% 2%',
    padding: '2%',
  },
  graphCardWrapper: {
    margin: '2% 2%',
    padding: '5px 2%',
  },
  headerWrapper: {
    backgroundColor: '#F7F7F7',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.5rem',
    marginBottom: '1rem',
    color: '#F37320',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  graphHeaderWrapper: {
    fontSize: '16px',
    color: '#F37320',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    marginBottom: '1rem',
    flexWrap: 'wrap'
  },
  graphHeading: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  bold: {
    fontWeight: 'bold',
  },
  rightBarView: {
    fontWeight: 'normal',
    color: '#026AE3',
    fontSize: '0.9rem',
    display: 'flex',
    alignItems: 'center',
  },
  rightBarViewMargin: { marginLeft: '0.5rem', marginRight: '0.5rem', cursor: 'pointer' },
  rightBarViewFlex: { display: 'flex', alignItems: 'center', color: '#F37320' },
  textAlignCenter: {
    textAlign: 'center'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  graphWrapper: {
    position: 'relative',
    cursor: 'pointer',
    '& .rv-xy-plot__axis__title': {
      color: '#6F6F6F',
      fontSize: '12px',
      transform: 'translate(10px, 70px)',
    },
    '& .rv-xy-plot__axis__tick__text': {
      '@media(max-width: 900px)': {
        // transform: 'translate(0px, 14px) rotate(-45deg)',
        // textAnchor: 'end',
      }
    }
  },
  crossHair: {
    zIndex: 2,
    position: 'absolute',

    '& .rv-crosshair__line': {
      background: 'rgba(123, 135, 147, 0.3)',
      width: '2px',
      height: '540px',

      '&::before': {
        content: "",
        position: 'absolute',
        top: 0,
        left: '-6px',
        borderColor: '#f7f8fc transparent transparent',
        borderStyle: 'solid',
        borderWidth: '8px 6px 0',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        bottom: 0,
        left: '-6px',
        borderColor: 'transparent transparent #f7f8fc',
        borderStyle: 'solid',
        borderWidth: '0 6px 8px',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      }
    },

    '& .rv-crosshair__inner': {
      marginRight: '2px',
      zIndex: 2,

      '&::before': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-5px',
        borderColor: 'transparent transparent transparent #d5dadd',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-4px',
        borderColor: 'transparent transparent transparent #ffffff',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      }
    },
    '& .rv-crosshair__inner--right': {
      '& .custom-hintbox': {
        left: '2%',
      }
    },

    '& .rv-crosshair__inner--left': {
      '& .custom-hintbox': {
        right: '2%',
      }
    },
  },
  hint: {
    zIndex: 99,
    position: 'absolute',

    '& .rv-crosshair__line': {
      background: 'rgba(123, 135, 147, 0.3)',
      width: '2px',

      '&::before': {
        content: "",
        position: 'absolute',
        top: 0,
        left: '-6px',
        borderColor: '#f7f8fc transparent transparent',
        borderStyle: 'solid',
        borderWidth: '8px 6px 0',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        bottom: 0,
        left: '-6px',
        borderColor: 'transparent transparent #f7f8fc',
        borderStyle: 'solid',
        borderWidth: '0 6px 8px',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      }
    },

    '& .rv-crosshair__inner': {
      marginRight: '2px',
      zIndex: 2,

      '&::before': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-5px',
        borderColor: 'transparent transparent transparent #d5dadd',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-4px',
        borderColor: 'transparent transparent transparent #ffffff',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      }
    },
  },
  hintCard: {
    width: '180px',
    padding: '5px 10px 5px',

    background: '#ffffff',
    color: '#000000',
    boxShadow: '0px 3px 6px #00000029',
    border: '1px solid #d7dbde',
    top: '20%',
    margin: '0 10px',
    position: 'absolute',
  },
  hintTextWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '5px',

    '& p': {
      fontSize: '12px'
    }
  },
  cardHeading: {
    fontFamily: 'Roboto',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.5px',
    color: 'rgba(123, 135, 147, 0.8)',
    marginBottom: '2px',
    textTransform: 'uppercase',
    textAlign: 'center'
  },
  cardKey: {
    color: '#6F6F6F',
    fontSize: '12px'
  },
  cardValue: {
    fontWeight: 'bold',
    color: '#6F6F6F',
    fontSize: '12px'
  },
  cardEvent: {
    color: '#6F6F6F',
    fontSize: '12px',
    wordBreak: 'break-all'
  },
  systemPendingButton: {
    borderRadius: '25px',
    width: '100px !important',
    margin: '0 5px',
    color: '#4A4A4A',
    borderColor: '#4A4A4A',
    height: '30px !important'
  },
  dialogText: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#545456'
  },
  dialogButton: {
    width: '180px',
    borderRadius: '25px'
  },
  batteryCapacity: {
    '& p': {
      maxWidth: '180px'
    }
  },
  batteryPower: {
    '& p': {
      maxWidth: '150px'
    }
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  dateWrapper: {
    display: 'flex',
    justifyContent: 'end',
    maxWidth: '500px',
    position: 'relative'
  },
  root: {
    position: 'absolute',
    background: '#FFFFFF',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '8px',
    top: '10px',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 10
  },
  calendarWrapper: {
    '& .MuiPickersDay-current': {
      color: 'rgba(0, 0, 0, 0.87)'
    },
    '& .rdrDayNumber': {
      '& span::after': {
        backgroundColor: '#F37320',
        display: 'none'
      },
    },
  },
  button: {
    color: '#F37320',
    margin: '0 10px 10px'
  },
  seriesLabel: {
    fontSize: '10px',
    color: '#707070'
  },
  backdrop: {
    zIndex: 1,
    color: '#fff'
  }
}))

export { programViewStyles }
